import React from 'react';
import Main from './main/Main';
import Header from './header/Header';
import Footer from './footer/Footer';
import AlertTemplate from './alert/AlertTemplate';
import { positions, Provider as AlertProvider, transitions } from 'react-alert';
import { hotjar } from 'react-hotjar';
import TagManager from 'react-gtm-module';
import Axios from 'axios';
import { useContext } from 'react';
import UserContext from './user/UserContext';
import RequestInterceptor from './common/RequestInterceptor';

hotjar.initialize(window.CONFIG['hotjar.hjid'], window.CONFIG['hotjar.hjsv']);
TagManager.initialize({
    gtmId: window.CONFIG['google_tag_manager_code']
});

let requestInterceptors = [];

function App() {

    const { userDetails } = useContext(UserContext);

    requestInterceptors.forEach(val => Axios.interceptors.request.eject(val));
    requestInterceptors = [];

    requestInterceptors.push(Axios.interceptors
        .request
        .use(cfg => RequestInterceptor(cfg, userDetails)));

    const alertOptions = {
        position: positions.TOP_RIGHT,
        timeout: 10000,
        transition: transitions.FADE,
        containerStyle: {
            margin: '60px 20px',
            zIndex: 100
        }
    };

    return (
        <div id={'content-wrapper'} className={'flex'}>
            <AlertProvider template={AlertTemplate} {...alertOptions}>
                <Header />
                <Main />
                <Footer />
            </AlertProvider>
        </div>
    );
}

export default App;
